/**
 * Product gallery: prev/next arrows directly on the main image, plus
 * autoplay for a video that becomes the active slide.
 *
 * Dawn's own main-viewer prev/next buttons drive `slider-component` by
 * scrolling its <ul>, but this theme's product page uses the "thumbnail"
 * (grid) gallery layout, where every non-active slide is `display: none` at
 * desktop widths (section-main-product.css). There is nothing to scroll to,
 * so that native behaviour is a no-op here. Instead, each click finds the
 * matching thumbnail for the next/previous media item and clicks it — the
 * same thumbnail button Dawn's own `media-gallery.js` already wires up to
 * `setActiveMedia()`, so active-state, ARIA and (per the autoplay fix below)
 * deferred video loading all stay perfectly in sync with clicking a
 * thumbnail directly. Dawn's native handler still runs first on the same
 * click and remains a harmless no-op (nothing left to scroll).
 */
(function () {
  function thumbnailItems(thumbnails) {
    return Array.from(thumbnails.querySelectorAll('.thumbnail-list__item[data-target]'));
  }

  function initGalleryNav(mediaGallery) {
    var viewer = mediaGallery.querySelector('[id^="GalleryViewer-"]');
    var thumbnails = mediaGallery.querySelector('[id^="GalleryThumbnails-"]');
    var buttons = viewer && viewer.querySelector('.slider-buttons');
    if (!viewer || !thumbnails || !buttons) return;

    var items = thumbnailItems(thumbnails);
    if (items.length < 2) {
      buttons.style.display = 'none';
      return;
    }

    var prevButton = buttons.querySelector('button[name="previous"]');
    var nextButton = buttons.querySelector('button[name="next"]');
    if (!prevButton || !nextButton) return;

    function goToStep(step) {
      var current = thumbnailItems(thumbnails);
      var activeIndex = current.findIndex(function (item) {
        return item.querySelector('button[aria-current]');
      });
      var fromIndex = activeIndex === -1 ? 0 : activeIndex;
      var nextIndex = (fromIndex + step + current.length) % current.length;
      var targetButton = current[nextIndex].querySelector('button');
      if (targetButton) targetButton.click();
    }

    prevButton.addEventListener('click', function (event) {
      event.preventDefault();
      goToStep(-1);
    });
    nextButton.addEventListener('click', function (event) {
      event.preventDefault();
      goToStep(1);
    });
  }

  function autoplayIfVideo(mediaItem) {
    if (!mediaItem) return;
    var deferred = mediaItem.querySelector('deferred-media');
    if (deferred && typeof deferred.loadContent === 'function' && !deferred.getAttribute('loaded')) {
      deferred.loadContent(false);
    }
  }

  function initAutoplay(mediaGallery) {
    var viewer = mediaGallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;

    // The initial active slide: autoplay immediately if it is a video, so a
    // video never needs an extra click just to start when it is the
    // default/featured media.
    autoplayIfVideo(viewer.querySelector('[data-media-id].is-active') || viewer.querySelector('[data-media-id]'));

    // Every later selection already reaches `deferred-media.loadContent()`
    // through Dawn's own `MediaGallery.playActiveMedia()` (media-gallery.js),
    // and the video tag already carries `autoplay: true`
    // (snippets/product-thumbnail.liquid), so no further wiring is needed
    // for thumbnail clicks or the arrows above.
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(function (mediaGallery) {
      initGalleryNav(mediaGallery);
      initAutoplay(mediaGallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
